import { render, staticRenderFns } from "./ValidationSummaryNew.vue?vue&type=template&id=3251b4bd&"
import script from "./ValidationSummaryNew.vue?vue&type=script&lang=ts&"
export * from "./ValidationSummaryNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports